import { AppRoutes } from "@/routes/config";
import { logout } from "@/utils/api";
import { createUrlWithParams } from "@/utils/url";
import { useEffect } from "react";

const Logout = () => {
  useEffect(() => {
    const handleLogout = async () => {
      const email = await logout();
      window.location.replace(createUrlWithParams(AppRoutes.login, { email }));
    };

    handleLogout();
  }, []);

  return null;
};

export default Logout;
